import { patchState, signalStoreFeature, withMethods, withState } from "@ngrx/signals";
import { SortMetadata } from './sort-metadata';

// TODO: multiple sort
export function withSort() {
  return signalStoreFeature(
    withState<{ sort: { sortField?: string, sortOrder?: number} }>({ sort: { } }),

    withMethods((state) => {
      return {
        setSortState: (sort: { sortField?: string, sortOrder?: number}) => {
          patchState(state, {
            sort: { ...sort },
          });
        },
        setMaterialSortEvent: (event: SortMetadata) => {
          const sortMeta = {
            asc: {sortField: event.active, sortOrder: 1},
            desc:  {sortField: event.active, sortOrder: -1},
            '': null
          }
          patchState(state, {
            sort: {...sortMeta[event.direction] }
          })
        }
      };
    })
  );
}
